<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V4.03081C6.63035 4.41192 3 8.282 3 13C3 17.9706 7.02944 22 12 22C16.9706 22 21 17.9706 21 13C21 8.282 17.3696 4.41192 12.75 4.03081V1ZM12.75 4.03081C12.5027 4.0104 12.2526 4 12 4C11.7474 4 11.4973 4.0104 11.25 4.03081V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15V4.03081Z" fill="currentColor"></path>
  </svg>
</template>
